import {
  PURCHASES_FETCHONE_SUCCESS,
  PURCHASES_GETALL_REQUEST,
  PURCHASES_GETALL_SUCCESS,
  PURCHASES_GETALL_FAILURE,
  PURCHASES_CREATEONE_SUCCESS,
  PURCHASES_UPDATEONE_SUCCESS,
} from '../actions/purchases';

export function purchases(
  state = { items: [], loading: false, total: 0 },
  action
) {
  const { items } = state;

  switch (action.type) {
    case PURCHASES_FETCHONE_SUCCESS:
      const index = items.findIndex((i) => i._id === action.item._id);
      return {
        ...state,
        items:
          index > -1
            ? items.map((item) =>
                item._id === action.item._id ? action.item : item
              )
            : [...items, action.item],
      };
    case PURCHASES_CREATEONE_SUCCESS:
      return {
        ...state,
        items: [...items, action.item],
      };
    case PURCHASES_UPDATEONE_SUCCESS:
      return {
        ...state,
        items: items.map((item) =>
          item._id === action.item._id ? action.item : item
        ),
      };
    case PURCHASES_GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PURCHASES_GETALL_SUCCESS:
      const fixed_items =
        action.items && action.items.items ? action.items.items : action.items;
      const total =
        action.items && action.items.total ? action.items.total : action.total;
      return {
        ...state,
        loading: false,
        items: fixed_items,
        total: total,
      };
    case PURCHASES_GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // case usersConstants.DELETE_REQUEST:
    //   // add 'deleting:true' property to user being deleted
    //   return {
    //     ...state,
    //     items: state.items.map(user =>
    //       user.id === action.id
    //         ? { ...user, deleting: true }
    //         : user
    //     )
    //   };
    // case usersConstants.DELETE_SUCCESS:
    //   // remove deleted user from state
    //   return {
    //     ...state,
    //     items: state.items.filter(user => user.id !== action.id)
    //   };
    // case usersConstants.DELETE_FAILURE:
    //   // remove 'deleting:true' property and add 'deleteError:[error]' property to user
    //   return {
    //     ...state,
    //     items: state.items.map(user => {
    //       if (user.id === action.id) {
    //         // make copy of user without 'deleting:true' property
    //         const { deleting, ...userCopy } = user;
    //         // return copy of user with 'deleteError:[error]' property
    //         return { ...userCopy, deleteError: action.error };
    //       }

    //       return user;
    //     })
    //   };
    default:
      return state;
  }
}
